import { default as ReleaseBeneficiariesCard } from "./BeneficiariesCard";
import { isFlagEnabled } from "js/utilities";

import DeprecatedBeneficiariesCard from "./DeprecatedBeneficiariesCard";
export default function BeneficiariesCard({ data }) {
  return isFlagEnabled("ENABLE_NO_BENEFICIARIES") ? (
    <ReleaseBeneficiariesCard data={data} />
  ) : (
    <DeprecatedBeneficiariesCard data={data} />
  );
}
